import React, { useState, useEffect } from 'react';
import { experiences as allExperiences } from '../data';
import Competitions from './Competitions';
import './Experience.css';

const SessionShowcase = ({ exp, index }) => (
  <div className="session-card reveal">
    {exp.image && (
      <div className="session-hero-img">
        <div className="session-img-number">{String(index + 1).padStart(2, '0')}</div>
        <img src={exp.image} alt={exp.role} />
        <div className="session-img-caption">
          <span>{exp.organization}</span>
          <span>{exp.date}</span>
        </div>
      </div>
    )}

    <div className="session-content-panel">
      <div className="session-strip">
        <span className="session-org-tag">{exp.organization.toUpperCase()}</span>
        <span className="session-type-tag">Speaking</span>
      </div>

      <h3 className="session-headline">{exp.role}</h3>

      <div className="session-details">
        <div className="session-detail-item">
          <span className="sd-label">Date</span>
          <span className="sd-val">{exp.date}</span>
        </div>
        <div className="session-detail-item">
          <span className="sd-label">Format</span>
          <span className="sd-val">Online Session</span>
        </div>
        <div className="session-detail-item">
          <span className="sd-label">Platform</span>
          <span className="sd-val">Microsoft Teams</span>
        </div>
        <div className="session-detail-item">
          <span className="sd-label">Audience</span>
          <span className="sd-val">Community · Tech</span>
        </div>
      </div>

      <p className="session-body">{exp.description}</p>

      {/* Tags */}
      <div className="session-tags">
        {['CNN', 'Computer Vision', 'AI', 'Beginner'].map(t => (
          <span key={t} className="session-chip">{t}</span>
        ))}
      </div>
    </div>
  </div>
);

const ExperienceItem = ({ exp, index }) => (
  <div className="vol-row">
    {/* Left: number + logo */}
    <div className="vol-row-left">
      <span className="vol-row-num">{String(index + 1).padStart(2, '0')}</span>
      {exp.logo ? (
        <img src={exp.logo} alt={exp.organization} className="vol-row-logo" />
      ) : (
        <div className="vol-row-logo-placeholder" />
      )}
    </div>

    {/* Center: org, role, description */}
    <div className="vol-row-center">
      <div className="vol-row-org">{exp.organization}</div>
      <div className="vol-row-role">{exp.role}</div>
      <p className="vol-row-desc">{exp.description}</p>
    </div>

    {/* Right: date */}
    <div className="vol-row-right">
      <div className="vol-row-date">{exp.date}</div>
      <div className="vol-row-tag">{exp.type}</div>
    </div>
  </div>
);

const Community = () => {
  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    setExperiences(allExperiences);
  }, []);

  const volExp = experiences.filter(e => e.type === 'Volunteering & Leadership');
  const sessions = experiences.filter(e => e.type === 'Sessions & Talks');

  return (
    <>
      <section id="volunteering" className="sec">
        <div className="sec-inner">
          <div className="sec-label">08 — Volunteering</div>
          <h2 className="sec-title">Community &<br /><em>Leadership</em></h2>

          <div className="vol-list reveal">
            {volExp.map((exp, index) => (
              <ExperienceItem key={exp._id || index} exp={exp} index={index} />
            ))}
          </div>
        </div>
      </section>

      {sessions.length > 0 && (
        <section id="sessions" className="sec">
          <div className="sec-inner">
            <div className="sec-label">09 — Speaking</div>
            <h2 className="sec-title">Knowledge Sharing &<br /><em>Sessions</em></h2>

            <div className="session-wrapper">
              {sessions.map((exp, index) => (
                <SessionShowcase key={exp._id || index} exp={exp} index={index} />
              ))}
            </div>
          </div>
        </section>
      )}

      {/* 10 — Competitions & Hackathons */}
      <Competitions />
    </>
  );
};

export default Community;
